module.exports = __webpack_public_path__ + "static/media/checked.8d127b13.svg";